import { createApp } from 'utils/vue';
import App from "areas/manage/components/pages/users/container";
import { registerHandler } from "utils/handler";

const handler = (app) => {
  createApp(App, app.data).mount("#app-container");
};

registerHandler("manage/users/index", handler);
